<template>
  <div class="page">
    <ion-grid fixed>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="rectangle">
        <ion-col>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Corporate ID
              </ion-label>
              <div class="section-desc margin-top-10">
                {{corporateId}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Corporate Name
              </ion-label>
              <div class="section-desc margin-top-10">
                {{corporateName}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Branch ID
              </ion-label>
              <div class="section-desc margin-top-10">
                {{branchId}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Branch Name
              </ion-label>
              <div class="section-desc margin-top-10">
               {{branch}}
              </div>
            </ion-col>
          </ion-row>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Mobile#1
              </ion-label>
              <div class="section-desc margin-top-10">
                {{mobile1}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Mobile#2
              </ion-label>
              <div class="section-desc margin-top-10">
                {{mobile2}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Landline
              </ion-label>
              <div class="section-desc margin-top-10">
                {{landline}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Primary Contact Person
              </ion-label>
              <div class="section-desc margin-top-10">
                {{primaryContactPerson}}
              </div>
            </ion-col>
          </ion-row>

          <ion-row align-items-stretch>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Secondary Contact Person
              </ion-label>
              <div class="section-desc margin-top-10">
                {{secondaryContactPerson}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                GST Number
              </ion-label>
              <div class="section-desc margin-top-10">
                {{gstNumber}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Email
              </ion-label>
              <div class="section-desc margin-top-10">
                {{email}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Status
              </ion-label>
              <div class="section-desc status-small margin-top-10" v-bind:class="[{'status-active': status.code == 'A'}, {'status-inactive': status.code == 'RET'}]">
                {{ convertUppercase(status.description) }}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding" v-if="retireReason != null">
              <ion-label class="section-item" position="stacked">
                Retire Reason
              </ion-label>
              <div class="section-desc margin-top-10">
                {{retireReason}}
              </div>
            </ion-col>
          </ion-row>

          <ion-row align-items-stretch>
            <ion-col class="col-padding">
              <ion-label class="secondary-text">Address</ion-label>
            </ion-col>
          </ion-row>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Building Name
              </ion-label>
              <div class="section-desc margin-top-10">
                {{line1}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Street Address
              </ion-label>
              <div class="section-desc margin-top-10">
                {{line2}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Area Name
              </ion-label>
              <div class="section-desc margin-top-10">
                {{line3}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked"> City </ion-label>
              <div class="section-desc margin-top-10">
                {{city}}
              </div>
            </ion-col>
          </ion-row>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked"> State </ion-label>
              <div class="section-desc margin-top-10">
                {{state.description}}
              </div>
            </ion-col>
            <ion-col size="12" size-md="3" class="col-padding">
              <ion-label class="section-item" position="stacked">
                Pincode
              </ion-label>
              <div class="section-desc margin-top-10">
                {{zipcode}}
              </div>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { CorporateService } from "../../service/corporate/corporate.service";
import { IonCol, IonGrid, IonLabel, IonRow, IonSpinner } from "@ionic/vue";
import moment from "moment";
import { migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";

export default defineComponent ({
  name: 'branchView',
  components: {
    IonGrid, IonRow, IonCol, IonLabel, IonSpinner
  },
  data() {
    return {
      loaderTab: false,
      corporateName: "",
      corporateId: "",
      branch: "",
      branchId: "",
      mobile1: "",
      mobile2: "",
      email: "",
      faxNumber: "",
      landline: "",
      primaryContactPerson: "",
      secondaryContactPerson: "",
      gstNumber: "",
      panNo: "",
      status: "",
      line1: "",
      line2: "",
      line3: "",
      city: "",
      state: "",
      zipcode: "",
      retireReason: ""
    }
  },
  async mounted() {
    try {
      let userBranchDetails = JSON.parse(localStorage.getItem('branchInfo'));
      if (userBranchDetails.branchId) {
        let branchDetails = await new CorporateService().getBranchDetailsById(
          // this.$route.params.corporateId
          userBranchDetails.branchId
        );
        this.fillCorporate(branchDetails);
      }
      this.loaderTab = false;
    } catch(error) {
      this.loaderTab = false;
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
    
  },
  methods: {
    convertUppercase(value) {
      if(value != undefined || value != null) {
        return value.toUpperCase()
      }
    },
    fillCorporate(branchDetails) {
      this.corporateName = branchDetails.corporateName;
      this.corporateId = branchDetails.corporateId;
      this.branch = branchDetails.branch;
      this.branchId = branchDetails.branchId;
      this.mobile1 = branchDetails.mobile1;
      this.primaryContactPerson = branchDetails.primaryContactPerson;
      this.gstNumber = branchDetails.gstNumber;
      this.email = branchDetails.email;
      this.status = branchDetails.status;
      this.mobile2 = branchDetails.mobile2;
      this.landline = branchDetails.landline;
      this.secondaryContactPerson = branchDetails.secondaryContactPerson
      this.line1 = branchDetails.addressLine1;
      this.line2 = branchDetails.addressLine2;
      this.line3 = branchDetails.addressLine3;
      this.city = branchDetails.city;
      this.state = branchDetails.state;
      this.zipcode = branchDetails.pincode;
      this.retireReason = branchDetails.retireReason;
    },
  }
})
</script>